import { useEffect } from "react";

const DEFAULT_TITLE = "INVIXA TRADERS | Trading Ecosystem";

function upsertMeta(selector, create) {
  let el = document.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

export function useSEO(title, description) {
  useEffect(() => {
    const full = title ? `${title} | INVIXA TRADERS` : DEFAULT_TITLE;
    document.title = full;

    const ogTitle = upsertMeta('meta[property="og:title"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:title");
      return m;
    });
    ogTitle.content = full;

    const twTitle = upsertMeta('meta[name="twitter:title"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "twitter:title");
      return m;
    });
    twTitle.content = full;

    if (description) {
      const desc = upsertMeta('meta[name="description"]', () => {
        const m = document.createElement("meta");
        m.name = "description";
        return m;
      });
      desc.content = description;

      const ogDesc = upsertMeta('meta[property="og:description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:description");
        return m;
      });
      ogDesc.content = description;
    }
  }, [title, description]);
}
